import * as React from "react";
import { createGRN } from "logic/permissions/GRN";
import useCurrentUser from "hooks/useCurrentUser";
import { hasAdminPermission } from "util/PermissionsMixin";
const HasOwnership = ({ children, id = void 0, type, hideChildren = false }) => {
  const currentUser = useCurrentUser();
  if (typeof children !== "function") {
    throw new Error('Invalid prop: "children" must be a function.');
  }
  if (hideChildren) {
    return null;
  }
  if (currentUser) {
    const { grnPermissions = [], permissions } = currentUser;
    const isAdmin = hasAdminPermission(permissions);
    const entity = createGRN(type, id);
    const ownership = `entity:own:${entity}`;
    if (grnPermissions.includes(ownership) || isAdmin) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, children({ disabled: false }), " ");
    }
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children({ disabled: true }), " ");
};
export default HasOwnership;
